export default {"src":"/_next/static/media/zhk-light-logo.5ee5a82e.svg","height":422,"width":589,"blurWidth":0,"blurHeight":0};